/**
 * Chart color configuration using design tokens
 * Single source of truth for all chart colors across the app
 */

import { colors } from "@ai-teach/config";

/**
 * FSRS card state colors
 */
export const CARD_STATE_COLORS = {
  new: colors.gray[500],
  learning: colors.accent[500],
  review: colors.success[500],
  relearning: colors.error[500],
} as const;

/**
 * Difficulty level colors
 */
export const DIFFICULTY_COLORS = {
  "0-3 (Easy)": colors.success[500],
  "3-5 (Medium)": colors.warning[500],
  "5-7 (Hard)": colors.accent[500],
  "7-9 (Very Hard)": colors.error[500],
  "9-11 (Extreme)": colors.error[700],
  Other: colors.gray[500],
} as const;

/**
 * Chart UI colors (grid, axes, tooltips, etc.)
 */
export const CHART_UI_COLORS = {
  grid: colors.gray[700],
  axis: colors.gray[400],
  tooltip: {
    background: colors.gray[800],
    border: colors.gray[700],
    label: colors.gray[400],
    text: colors.gray[200],
  },
  legend: colors.gray[400],
} as const;

/**
 * Primary data visualization colors
 */
export const DATA_VIZ_COLORS = {
  primary: colors.primary[500],
  secondary: colors.secondary[500],
  success: colors.success[500],
  warning: colors.warning[500],
  error: colors.error[500],
  accent: colors.accent[500],
} as const;

/**
 * Gradient definitions for area charts
 */
export const CHART_GRADIENTS = {
  primary: {
    id: "primaryGradient",
    color: colors.primary[500],
  },
  secondary: {
    id: "secondaryGradient",
    color: colors.secondary[500],
  },
  success: {
    id: "successGradient",
    color: colors.success[500],
  },
  error: {
    id: "errorGradient",
    color: colors.error[500],
  },
  gray: {
    id: "grayGradient",
    color: colors.gray[500],
  },
  accent: {
    id: "accentGradient",
    color: colors.accent[500],
  },
} as const;
